import { CandidateProfessionalAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';
import type { ICandidateProfessionalEntity, IGetCandidateProfessionalPayload } from '../types';

export const getCandidateProfessional = async (
  payload: IGetCandidateProfessionalPayload,
): Promise<ICandidateProfessionalEntity> => {
  const response = await PermanentJobsApi.getCandidateProfessional(payload);

  return CandidateProfessionalAdapters.toGetCandidateProfessionalEntity(response);
};
